module.exports = __webpack_public_path__ + "img/图表区.jpg";